/*
 Created by qing on 2020/12/29
 Des:
 */
import AppsConfig from "./AppsConfig";
import DashboardConfig from "./DashboardConfig";
import QuickEntryConfig from "./QuickEntryConfig";
import TodoConfig from "./TodoConfig";
import ContactMe from "./ContactMe";

import {
  CONFIG_TYPE__APPS,
  CONFIG_TYPE__DASHBOARD,
  CONFIG_TYPE__QUICK_ENTRY,
  CONFIG_TYPE__TODO,
  CONFIG_TYPE__CONTACT_ME
} from "../type";

export default {
  ['control_' + CONFIG_TYPE__APPS]: AppsConfig,
  ['control_' + CONFIG_TYPE__DASHBOARD]: DashboardConfig,
  ['control_' + CONFIG_TYPE__QUICK_ENTRY]: QuickEntryConfig,
  ['control_' + CONFIG_TYPE__TODO]: TodoConfig,
  ['control_' + CONFIG_TYPE__CONTACT_ME]: ContactMe
}
